import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Teleport as _Teleport, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/logo-lion-parcel-red.svg'
import _imports_1 from '@/app/ui/assets/svg/cod-logo-3.svg'
import _imports_2 from '@/app/ui/assets/svg/new-dfod-2.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-05aabd69")

_pushScopeId("data-v-05aabd69")
const _hoisted_1 = {
  key: 0,
  class: "flex flex-col absolute",
  id: "invoice-png-a4"
}
const _hoisted_2 = {
  class: "absolute top-1/2 left-1/2",
  style: {"transform":"translate(-50%, -50%)"}
}
const _hoisted_3 = { class: "p-3 w-full h-full" }
const _hoisted_4 = {
  key: 0,
  class: "flex flex-row items-center justify-between"
}
const _hoisted_5 = {
  class: "font-bold text-blue-lp-700",
  style: {"font-size":"1.25rem"}
}
const _hoisted_6 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_7 = {
  key: 1,
  class: "flex flex-row gap-3 items-baseline w-full content"
}
const _hoisted_8 = { class: "w-1/2" }
const _hoisted_9 = { class: "rounded-md bg-gray-lp-1000 py-1 px-2 flex flex-row items-baseline gap-4" }
const _hoisted_10 = { class: "w-1/2 flex flex-col gap-1" }
const _hoisted_11 = { class: "flex flex-row gap-4" }
const _hoisted_12 = { style: {"width":"65px"} }
const _hoisted_13 = { class: "flex flex-row gap-0.5" }
const _hoisted_14 = /*#__PURE__*/_createVNode("p", null, ":", -1)
const _hoisted_15 = { class: "flex flex-row gap-4" }
const _hoisted_16 = { style: {"width":"65px"} }
const _hoisted_17 = { class: "flex flex-row gap-0.5" }
const _hoisted_18 = /*#__PURE__*/_createVNode("p", null, ":", -1)
const _hoisted_19 = { class: "w-1/2 flex flex-col gap-1" }
const _hoisted_20 = { class: "flex flex-row gap-4" }
const _hoisted_21 = { style: {"width":"65px"} }
const _hoisted_22 = { class: "flex flex-row gap-0.5" }
const _hoisted_23 = /*#__PURE__*/_createVNode("p", null, ":", -1)
const _hoisted_24 = { class: "flex flex-row gap-4" }
const _hoisted_25 = { style: {"width":"65px"} }
const _hoisted_26 = { class: "flex flex-row gap-0.5" }
const _hoisted_27 = /*#__PURE__*/_createVNode("p", null, ":", -1)
const _hoisted_28 = { class: "w-1/2" }
const _hoisted_29 = { class: "rounded-md bg-gray-lp-1000 py-1 px-2 flex flex-row items-baseline gap-4" }
const _hoisted_30 = { class: "w-1/2 flex flex-col gap-1" }
const _hoisted_31 = { class: "flex flex-row gap-4" }
const _hoisted_32 = { style: {"width":"65px"} }
const _hoisted_33 = { class: "flex flex-row gap-0.5" }
const _hoisted_34 = /*#__PURE__*/_createVNode("p", null, ":", -1)
const _hoisted_35 = { class: "flex flex-row gap-4" }
const _hoisted_36 = { style: {"width":"65px"} }
const _hoisted_37 = { class: "flex flex-row gap-0.5" }
const _hoisted_38 = /*#__PURE__*/_createVNode("p", null, ":", -1)
const _hoisted_39 = { class: "w-1/2 flex flex-col gap-1" }
const _hoisted_40 = { class: "flex flex-row gap-4" }
const _hoisted_41 = { style: {"width":"65px"} }
const _hoisted_42 = { class: "flex flex-row gap-0.5" }
const _hoisted_43 = /*#__PURE__*/_createVNode("p", null, ":", -1)
const _hoisted_44 = { class: "content w-full pt-2 flex flex-row gap-3" }
const _hoisted_45 = {
  key: 0,
  class: "w-full invoice-table"
}
const _hoisted_46 = { style: {"width":"20px"} }
const _hoisted_47 = { style: {"width":"78px"} }
const _hoisted_48 = { style: {"width":"60px"} }
const _hoisted_49 = { style: {"width":"60px"} }
const _hoisted_50 = { style: {"width":"70px"} }
const _hoisted_51 = { class: "flex flex-col" }
const _hoisted_52 = { class: "text-gray-lp-600 font-medium" }
const _hoisted_53 = { style: {"width":"50px"} }
const _hoisted_54 = { style: {"width":"50px"} }
const _hoisted_55 = { class: "flex flex-col gap-0.5" }
const _hoisted_56 = { class: "flex flex-row items-center text-gray-lp-600 gap-0.5" }
const _hoisted_57 = {
  key: 0,
  style: {"height":"4.7px"},
  src: _imports_1,
  alt: "cod"
}
const _hoisted_58 = {
  key: 1,
  style: {"height":"4.7px"},
  src: _imports_2,
  alt: "cod"
}
const _hoisted_59 = { class: "flex flex-col gap-0.5" }
const _hoisted_60 = {
  class: "whitespace-nowrap overflow-ellipsis overflow-hidden",
  style: {"width":"60px"}
}
const _hoisted_61 = { class: "text-gray-lp-600" }
const _hoisted_62 = { class: "flex flex-col gap-0.5" }
const _hoisted_63 = { class: "text-gray-lp-600" }
const _hoisted_64 = { class: "flex flex-col gap-0.5" }
const _hoisted_65 = {
  key: 2,
  class: "text-gray-lp-600"
}
const _hoisted_66 = {
  key: 0,
  class: "font-semibold"
}
const _hoisted_67 = {
  key: 1,
  class: "font-semibold"
}
const _hoisted_68 = {
  key: 2,
  class: "font-semibold"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.show)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.chunkedPages, (page, pageIdx) => {
            return (_openBlock(), _createBlock("div", {
              class: "relative",
              style: {"min-width":"842px","max-width":"842px","min-height":"595px","max-height":"595px"},
              key: pageIdx,
              id: `invoice-pdf-a4-${pageIdx}`
            }, [
              _createVNode("div", _hoisted_2, [
                _createVNode("div", {
                  class: ["watermark", [
              { paid: _ctx.invoiceData.status === 'paid' },
              { unpaid: _ctx.invoiceData.status !== 'paid' },
              { ID: _ctx.countryCode.toUpperCase() === 'ID' }
            ]]
                }, _toDisplayString(_ctx.invoiceData.status === "paid"
                ? _ctx.$t("tagihan.status.paid")
                : _ctx.$t("tagihan.status.unpaid")), 3)
              ]),
              _createVNode("div", _hoisted_3, [
                (pageIdx === 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_4, [
                      _createVNode("span", _hoisted_5, _toDisplayString(_ctx.invoiceData.invoiceNo), 1),
                      _hoisted_6
                    ]))
                  : _createCommentVNode("", true),
                (pageIdx === 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_7, [
                      _createVNode("div", _hoisted_8, [
                        _createVNode("div", _hoisted_9, [
                          _createVNode("div", _hoisted_10, [
                            _createVNode("div", _hoisted_11, [
                              _createVNode("p", _hoisted_12, _toDisplayString(_ctx.$t("tagihan.pdf.billedTo")), 1),
                              _createVNode("div", _hoisted_13, [
                                _hoisted_14,
                                _createVNode("p", null, _toDisplayString(_ctx.invoiceData.billedToName) + " (" + _toDisplayString(_ctx.invoiceData.billedToPhone) + ")", 1)
                              ])
                            ]),
                            _createVNode("div", _hoisted_15, [
                              _createVNode("p", _hoisted_16, _toDisplayString(_ctx.$t("tagihan.pdf.createdBy")), 1),
                              _createVNode("div", _hoisted_17, [
                                _hoisted_18,
                                _createVNode("p", null, _toDisplayString(_ctx.invoiceData.referenceName), 1)
                              ])
                            ])
                          ]),
                          _createVNode("div", _hoisted_19, [
                            _createVNode("div", _hoisted_20, [
                              _createVNode("p", _hoisted_21, _toDisplayString(_ctx.$t("tagihan.table.createdAt")), 1),
                              _createVNode("div", _hoisted_22, [
                                _hoisted_23,
                                _createVNode("p", null, _toDisplayString(_ctx.formatDateNormal(_ctx.invoiceData.createdAt, "DD MMM YYYY")), 1)
                              ])
                            ]),
                            _createVNode("div", _hoisted_24, [
                              _createVNode("p", _hoisted_25, _toDisplayString(_ctx.$t("tagihan.form.totalStt")), 1),
                              _createVNode("div", _hoisted_26, [
                                _hoisted_27,
                                _createVNode("p", null, _toDisplayString(_ctx.invoiceData.totalStt), 1)
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_28, [
                        _createVNode("div", _hoisted_29, [
                          _createVNode("div", _hoisted_30, [
                            _createVNode("div", _hoisted_31, [
                              _createVNode("p", _hoisted_32, _toDisplayString(_ctx.$t("tagihan.modal.totalAmount")), 1),
                              _createVNode("div", _hoisted_33, [
                                _hoisted_34,
                                _createVNode("strong", null, _toDisplayString(_ctx.formatPriceAmount(_ctx.invoiceData.totalAmount)), 1)
                              ])
                            ]),
                            _createVNode("div", _hoisted_35, [
                              _createVNode("p", _hoisted_36, _toDisplayString(_ctx.$t("tagihan.modal.remainingLabel")), 1),
                              _createVNode("div", _hoisted_37, [
                                _hoisted_38,
                                _createVNode("strong", null, _toDisplayString(_ctx.formatPriceAmount(_ctx.invoiceData.balanceDue)), 1)
                              ])
                            ])
                          ]),
                          _createVNode("div", _hoisted_39, [
                            _createVNode("div", _hoisted_40, [
                              _createVNode("p", _hoisted_41, _toDisplayString(_ctx.$t("tagihan.pdf.note")), 1),
                              _createVNode("div", _hoisted_42, [
                                _hoisted_43,
                                _createVNode("p", null, _toDisplayString(_ctx.invoiceData.note), 1)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_44, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(page, (tables, index) => {
                    return (_openBlock(), _createBlock("div", {
                      key: index,
                      class: ["w-1/2", [{'pr-1': page.length === 1}]]
                    }, [
                      (tables.length && tables[0].sttNo !== '-')
                        ? (_openBlock(), _createBlock("table", _hoisted_45, [
                            _createVNode("thead", null, [
                              _createVNode("th", _hoisted_46, _toDisplayString(_ctx.$t("tagihan.pdf.no")), 1),
                              _createVNode("th", _hoisted_47, _toDisplayString(_ctx.$t("tagihan.pdf.sttNo")), 1),
                              _createVNode("th", _hoisted_48, _toDisplayString(_ctx.$t("tagihan.table.createdAt")), 1),
                              _createVNode("th", _hoisted_49, _toDisplayString(_ctx.$t("tagihan.pdf.recipient")), 1),
                              _createVNode("th", _hoisted_50, [
                                _createVNode("div", _hoisted_51, [
                                  _createTextVNode(_toDisplayString(_ctx.$t("tagihan.table.productType")) + " ", 1),
                                  _createVNode("span", _hoisted_52, _toDisplayString(_ctx.$t("tagihan.pdf.chargeableWeight")), 1)
                                ])
                              ]),
                              _createVNode("th", _hoisted_53, _toDisplayString(_ctx.$t("tagihan.pdf.totalTariff")), 1),
                              _createVNode("th", _hoisted_54, _toDisplayString(_ctx.$t("tagihan.modal.totalAmount")), 1)
                            ]),
                            _createVNode("tbody", null, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(tables, (item, idx) => {
                                return (_openBlock(), _createBlock("tr", { key: idx }, [
                                  _createVNode("td", null, _toDisplayString(item.no), 1),
                                  _createVNode("td", null, [
                                    _createVNode("div", _hoisted_55, [
                                      _createTextVNode(_toDisplayString(item.sttNo) + " ", 1),
                                      _createVNode("div", _hoisted_56, [
                                        (item.isCod && !item.isDfod)
                                          ? (_openBlock(), _createBlock("img", _hoisted_57))
                                          : _createCommentVNode("", true),
                                        (item.isCod && item.isDfod)
                                          ? (_openBlock(), _createBlock("img", _hoisted_58))
                                          : _createCommentVNode("", true),
                                        _createTextVNode(" " + _toDisplayString(item.shipmentId), 1)
                                      ])
                                    ])
                                  ]),
                                  _createVNode("td", null, _toDisplayString(_ctx.formatDateNormal(item.createdAt, "DD MMMM")), 1),
                                  _createVNode("td", null, [
                                    _createVNode("div", _hoisted_59, [
                                      _createVNode("div", _hoisted_60, _toDisplayString(item.recipientName), 1),
                                      _createVNode("span", _hoisted_61, _toDisplayString(item.recipientPhoneMasked), 1)
                                    ])
                                  ]),
                                  _createVNode("td", null, [
                                    _createVNode("div", _hoisted_62, [
                                      _createTextVNode(_toDisplayString(item.productType) + " ", 1),
                                      _createVNode("span", _hoisted_63, _toDisplayString(item.chargeableWeight) + " Kg", 1)
                                    ])
                                  ]),
                                  _createVNode("td", null, [
                                    _createVNode("div", _hoisted_64, [
                                      (item.isCod || item.isDfod)
                                        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                            _createTextVNode(_toDisplayString(_ctx.formatPriceAmount(item.tariff)), 1)
                                          ], 64))
                                        : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                            _createTextVNode(_toDisplayString(_ctx.formatPriceAmount(item.amount)), 1)
                                          ], 64)),
                                      (item.isCashless)
                                        ? (_openBlock(), _createBlock("span", _hoisted_65, "Cashless"))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _createVNode("td", null, [
                                    (item.paymentLabel === 'paid_by_recipient')
                                      ? (_openBlock(), _createBlock("span", _hoisted_66, _toDisplayString(_ctx.$t("tagihan.table.paidByRecipient")), 1))
                                      : (item.paymentLabel === 'paid_via_app')
                                        ? (_openBlock(), _createBlock("span", _hoisted_67, _toDisplayString(_ctx.$t("tagihan.table.paidViaApp")), 1))
                                        : (_openBlock(), _createBlock("span", _hoisted_68, _toDisplayString(_ctx.formatPriceAmount(item.amount)), 1))
                                  ])
                                ]))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 2))
                  }), 128))
                ])
              ])
            ], 8, ["id"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
})